import React, { Component } from 'react';
import { Router, Route, Switch, withRouter } from 'react-router-dom';
import createBrowserHistory from 'history/createBrowserHistory';
import App from './App';
import AboutMe from './AboutMe';
import Work from './Work';
// Work history
import PortfolioMonoShift from './PortfolioMonoShift';
import PortfolioOutware from './PortfolioOutware';
import PortfolioSportsmate from './PortfolioSportsmate';
import PortfolioIBA from './PortfolioIBA';
import PortfolioPersonal from './PortfolioPersonalWork';
import PortfolioSEEK from './PortfolioSEEK';
import PortfolioMedibank from './PortfolioMedibank';
import PortfolioPerformanceLeader from './PortfolioPerformanceLeader';

// Art
import ArtTest from './ArtTest';

// Case study
import CasestudyAIAVitality from './CasestudyAIAVitality';

import NotFound from './NotFound';
import Contact from './Contact';
// testing for every portfolio case
import PortfolioUI from './PortfolioUI';

const history = createBrowserHistory();

class ScrollToTop extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0)
    }
  }

  render() {
    return this.props.children
  }
}

const WrappedScrollToTop = withRouter(ScrollToTop);

// 여기에 링크를 주렁주렁 다는구만!!!!!
const SiteRouter = () => (
  <Router history={history}>
    <WrappedScrollToTop>
      <Switch>
        {/* About & contact */}
        <Route exact path="/" component={App}/>
        <Route path="/about" component={AboutMe}/>
        <Route path="/work" component={Work}/>
        <Route path="/testing-playground" component={PortfolioUI}/>
        <Route path="/contact" component={Contact}/>

        {/*  Work history  */}
        <Route path="/monoshift" component={PortfolioMonoShift}/>
        <Route path="/outware" component={PortfolioOutware}/>
        <Route path="/sportsmate" component={PortfolioSportsmate}/>
        <Route path="/personal" component={PortfolioPersonal}/>
        <Route path="/performanceLeader" component={PortfolioPerformanceLeader}/>
        <Route path="/seek" component={PortfolioSEEK}/>
        <Route path="/ittybittyapps" component={PortfolioIBA}/>
        <Route path="/medibank" component={PortfolioMedibank}/>
        <Route path="/artTest" component={ArtTest}/>

        {/* website functional - 404, etc */}
        <Route component={NotFound} />
      </Switch>
    </WrappedScrollToTop>
  </Router>
);

export default SiteRouter;



// WEBPACK FOOTER //
// ./src/Router.js